import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Certification } from "@common/models/certification";
import { environment } from "environments/environment";
import { throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";


@Injectable({ providedIn: "root" })
export class CertificationService {
  constructor(private _http: HttpClient) { }

  getAll() {
    return this._http.get<Certification[]>(`${environment.commonApiUrl}/api/certification`)
  }

  getById(id: number) {
    return this._http.get<Certification>(`${environment.commonApiUrl}/api/certification/${id}`);
  }

  addCertification(certification) {
    return this._http.post<Certification>(`${environment.commonApiUrl}/api/certification`, certification).pipe(
      map((response: any) => response.certification as Certification),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  editCertification(certification) {
    return this._http.put<Certification>(`${environment.commonApiUrl}/api/certification/${certification.id}`, certification).pipe(
      map((response: any) => response.certification as Certification),
      catchError(e => {
        return throwError(e);
      })
    );
  }

  changeStatus(id: number, statusId: number) {
    return this._http.put<Certification>(`${environment.commonApiUrl}/api/certification/${id}/${statusId}`, {}).pipe(
      map((response: any) => response.certification as Certification),
      catchError(e => {
        return throwError(e);
      })
    );
  }
}
